import React from 'react';
import { Box, Button, Tooltip } from '@mui/material';

interface PageHeaderActionProps {
  label: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  icon?: React.ReactNode;
  endIcon?: React.ReactNode;
  disabled?: boolean;
  'data-testid'?: string;
  'aria-controls'?: string;
  'aria-haspopup'?: boolean | 'true' | 'false';
  'aria-expanded'?: boolean | 'true' | 'false';
}

export const PageHeaderAction: React.FC<PageHeaderActionProps> = ({
  label,
  onClick,
  icon,
  endIcon,
  disabled,
  'data-testid': testId,
  'aria-controls': ariaControls,
  'aria-haspopup': ariaHasPopup,
  'aria-expanded': ariaExpanded,
}) => {
  const button = (
    <Button
      variant="text"
      size="small"
      startIcon={icon}
      endIcon={endIcon}
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      aria-label={label}
      aria-controls={ariaControls}
      aria-haspopup={ariaHasPopup}
      aria-expanded={ariaExpanded}
      sx={{
        color: 'text.secondary',
        '& .MuiButton-startIcon > *': { fontSize: '14px !important' },
        '& .MuiButton-endIcon > *': { fontSize: '14px !important' },
        ...(icon && {
          minWidth: { xs: 'auto', sm: undefined },
          px: { xs: 0.75, sm: undefined },
          '& .MuiButton-startIcon': { mr: { xs: 0, sm: 0.5 } },
          '& .MuiButton-endIcon': { display: { xs: 'none', sm: 'inherit' } },
        }),
      }}
    >
      {icon ? (
        <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
          {label}
        </Box>
      ) : (
        label
      )}
    </Button>
  );

  return icon ? <Tooltip title={label}>{button}</Tooltip> : button;
};
